import { SYSTEM_ERROR } from "../config/CONSTANTS";
import {
  SEARCH_PRODUCT_VARIENT,
  GET_INCOMING_INVENTORIES,
  SAVE_INCOMING_INVENTORIES,
  UPDATE_INCOMING_INVENTORY,
  REMOVE_INCOMING_INVENTORIES,
} from "./CONSTANTS";
import axiosInstance from "../utils/axiosInstance";

export const getIncomingInventories = (queryparams) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(GET_INCOMING_INVENTORIES(), {
          params: queryparams,
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject("Error in getIncomingInventories Axios!");
        });
    } catch (error) {
      console.error(
        "in incomingInventoryService > getIncomingInventories, Err",
        error
      );
      reject(SYSTEM_ERROR);
    }
  });
};

export const getProductVarients = (queryparams) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(SEARCH_PRODUCT_VARIENT(), {
          params: queryparams,
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject("Error in getProductVarients Axios!");
        });
    } catch (error) {
      console.error(
        "in incomingInventoryService > getProductVarients, Err",
        error
      );
      reject(SYSTEM_ERROR);
    }
  });
};

export const saveIncomingInventory = (incomingInventoryObject) => {

  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(SAVE_INCOMING_INVENTORIES(), incomingInventoryObject)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject("Error in saveIncomingInventory Axios!");
        });
    } catch (error) {
      console.error(
        "in incomingInventoryService > saveIncomingInventory, Err===",
        error
      );
      reject(SYSTEM_ERROR);
    }
  });
};

export const updateIncomingInventory = (incomingInventoryObject) => {

  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(UPDATE_INCOMING_INVENTORY(), incomingInventoryObject)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject("Error in updateIncomingInventory Axios!");
        });
    } catch (error) {
      console.error(
        "in incomingInventoryService > updateIncomingInventory, Err===",
        error
      );
      reject(SYSTEM_ERROR);
    }
  });
};

export const removeIncomingInventory = (removeIncomingInventoryObject) => {

  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(REMOVE_INCOMING_INVENTORIES(), removeIncomingInventoryObject)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject("Error in removeIncomingInventoryObject Axios!");
        });
    } catch (error) {
      console.error(
        "in incomingInventoryService > removeIncomingInventoryObject, Err===",
        error
      );
      reject(SYSTEM_ERROR);
    }
  });
};
